import React from 'react';
import { Box } from '@mui/material'

import Image1 from '../../../images/tour/Führungen_1.jpg';
import Image2 from '../../../images/tour/Führungen_2.jpg';
import Image3 from '../../../images/tour/Führungen_3.jpg'
import Image4 from '../../../images/tour/Führungen_4.jpg'
import Image5 from '../../../images/tour/Führungen_5.jpg';


import Carousel, { consts } from 'react-elastic-carousel';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

var items = [
    {
        image: Image1,
    },
    {
        image: Image2,
    },
    {
        image: Image3,
    },
    {
        image: Image4,
    },
    {
        image: Image5,
    }
]




export default function Photogallery() {

    return (
        <Box sx={{
        }}>
            <div className='carousel-g'>
                <Carousel
                    itemsToShow={3}
                    itemsToScroll={1}
                    itemPadding={[0, 5, 0, 5]}
                    enableSwipe={true}
                    disableArrowsOnEnd={false}
                    pagination={false}
                    renderArrow={({ type, onClick }) => {
                        const pointer = type === consts.PREV ? <SlArrowLeft className='arrows' /> :
                            <SlArrowRight className='arrows' />
                        return <button onClick={onClick} className='arrows'>{pointer}</button>
                    }}
                >
                    {
                        items.map((item, index) => <Item key={index} item={item} />)
                    }
                </Carousel>
            </div>

            <div className='carousel-v'>
                <Carousel
                    itemsToShow={1}
                    itemsToScroll={1}
                    itemPadding={[0, 5, 0, 5]}
                    enableSwipe={false}
                    disableArrowsOnEnd={false}
                    pagination={false}
                    showArrows={true}
                    renderArrow={({ type, onClick }) => {
                        const pointer = type === consts.PREV ? <SlArrowLeft className='arrows' /> :
                            <SlArrowRight className='arrows' />
                        return <button onClick={onClick} className='arrows'>{pointer}</button>
                    }}
                >
                    {
                        items.map((item, index) => <Item key={index} item={item} />)
                    }
                </Carousel>

            </div>
        </Box>

    )


}

function Item(props) {
    return (
        <Box>
            <img src={props.item.image} width={'100%'} alt="Item"/>
        </Box>
    )
}

